// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"8363fe45","671":"c9644ae3","928":"afaf07f9"}[chunkId] + ".chunk.css";
};